import { render } from "./Logo.vue?vue&type=template&id=382413e8&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=382413e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-382413e8"

export default script